"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageEligibilityResponseBenefit = void 0;
/**
 * This resource provides eligibility and plan details from the processing of an CoverageEligibilityRequest resource.
 */
var CoverageEligibilityResponseBenefit = /** @class */ (function () {
    function CoverageEligibilityResponseBenefit() {
    }
    return CoverageEligibilityResponseBenefit;
}());
exports.CoverageEligibilityResponseBenefit = CoverageEligibilityResponseBenefit;
